import UserManagement from "../components/UserManagement/UserManagement";

const Users = () => {
    return <UserManagement></UserManagement>;
}

export default Users;